import { useContext } from "react";
import { SettingsContext } from "./context";

export const useSettings = () => {
    const context = useContext(SettingsContext);

    if (context) {
        return context;
    }

    throw new Error(`useSettingsContext must be used within the context`);
};
